module.exports = __webpack_public_path__ + "img/05-oval-not-convex-1.acd2513b.svg";